<template>
    <div :class="statsAvilable == true ? 'container' : 'container-min'">
      <div class="container-header row">
        <div class="row icon">
          <img :src="getWorkoutIcon(data.workout_type)" style="min-width: 3.2rem;" alt="Walking Icon" />
        </div>
        <div class="row date">
          <div class="activity-date">{{ formatDate(data.workout_timestamp) }}</div>
          <div class="activity-time">{{formatUnixTimeStamp(data.workout_record_start_time)}} 
                - {{formatUnixTimeStamp(data.workout_record_end_time)}}</div>
        </div>
      </div>
      <div v-if="statsAvilable" class="container-body" style="padding-top: 1rem;padding-left: 1rem;">
        <div class="d-flex justify-content-between" style="width: 100%;">
            <div class="stat col" style="width: 50%;">
                <div class="row">
                    <div class="label">Duration</div>
                    <div class="col">
                        <icon-duration class="icon-padding" />
                        <span class="value">{{ formatDurationInHrsAndMins(data.workout_exercise_duration) }}</span>
                    </div>
                </div>
            </div>
            <div class="stat col" style="width: 50%;">
                <div class="row">
                    <div class="label">Distance(km)</div>
                    <div class="col">
                        <icon-location class="icon-padding" />
                        <span class="value">{{ data.workout_record_distance/1000 }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-between" style="width: 100%;">
          <div class="stat col" style="width: 50%;">
            <div class="row">
                <div class="label">Calories(kcal)</div>
                <div class="col">
                    <icon-calories :size="'0.9rem'" class="icon-padding" />
                    <span class="value">{{ data.workout_record_calorie }}</span>
                </div>
            </div>
          </div>
          <div class="stat col" style="width: 50%;">
            <div class="row">
                <span class="label">Speed(km/h)</span>
                <div class="col">
                    <icon-speed class="icon-padding" />
                    <span class="value">{{getSpeed()}}</span>
                </div>
            </div>
           </div>
        </div>
      </div>
      <div v-else class="container-body" style="padding-top: 1rem;padding-left: 1rem;">
        <div class="d-flex justify-content-around" style="width: 100%;">
            <div class="stat col" style="width: 50%;">
                <div class="row">
                    <div class="label">Duration</div>
                    <div class="col">
                        <icon-duration class="icon-padding" />
                        <span class="value">{{ formatDurationInHrsAndMins(data.workout_exercise_duration) }}</span>
                    </div>
                </div>
            </div>
            <div class="stat col" style="width: 50%;">
            <div class="row">
                <div class="label">Calories(kcal)</div>
                <div class="col">
                    <icon-calories :size="'0.9rem'" class="icon-padding" />
                    <span class="value">{{ data.workout_record_calorie }}</span>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  const dayjs = require("dayjs");
  import Utils from "@/helpers/utils";
  import DateUtils from "@/helpers/dateUtils";
  import Constants from "@/helpers/constants.js";
  import IconCalories from "@/shared/Controls/Icons/IconCalories.vue";
  import IconDuration from "@/shared/Controls/Icons/IconDuration.vue";
  import IconLocation from "@/shared/Controls/Icons/IconLocation.vue";
  import IconSpeed from "@/shared/Controls/Icons/IconSpeed.vue";

  export default {
    name: "ActivityDetails",
    components:{
        IconCalories,
        IconDuration,
        IconLocation,
        IconSpeed
    },
    props: {
      data: {
        type: Object,
        required: true,
      },
      statsAvilable: {
        type: Boolean,
        required: true,
      }
    },
    methods: {
        formatDate(date) {
            return dayjs(date).format(Constants.TABLE_DOB_FORMAT)
        },
        formatUnixTimeStamp(unixTime) {
           return DateUtils.formatUnixTimeStamp(unixTime).toUpperCase();
        },
        formatDurationInHrsAndMins(durationInSec) {
          let secs = Math.round((durationInSec/1000));
          return Utils.formatDurationInHrsAndMins(secs);
        },
        getWorkoutIcon(workoutType) {
           return Utils.getWorkoutIcon(workoutType);
        },
        getSpeed() {
            let speed = Utils.formatSpeed(this.data.workout_record_distance, this.data.workout_exercise_duration);
            return `${speed}`
        }
    },
    mounted() {
        //console.log('workoutdata -> '+JSON.stringify(this.data))
    },
  };
  </script>
  
  <style lang="scss" scoped>
    .container {
        background-color: #1C1D1F !important; 
        color: #ffffff;
        border-radius: 0.5rem;
        padding: 1rem;
    }
    .container-header {
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .icon {
        width: 4rem;
        height: 4rem;
        background-color: #4a5d67;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
    }
    .icon img {
        width: 3rem;
        height: 3rem;
    }
    .date {
        font-size: 14px;
        line-height: 1.2;
        padding-top: 1rem;
    }
    .container-body {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    .stat {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
    }
    .label {
        color: #b0bec5;
        font-size: 0.75rem;
        font-weight: 600;
    }
    .value {
        color: #ffffff;
        /* font-weight: bold; */
        font-size: 1rem;
    }
    .activity-date {
        font-size: 1rem;
        font-weight: 500;
        padding-left: 3rem;
    }
    .activity-time {
        font-size: 0.9rem;
        color: #909ea0;
        font-weight: 500;
        padding-left: 1.8rem;
    }
    .icon-padding {
        padding-bottom: 0.2rem;;
    }
    .container-min {
        background-color: #1C1D1F !important; 
        color: #ffffff;
        border-radius: 0.5rem;
        padding: 1rem;
        min-height: 14rem;
    }
  </style>
  